import { type Infer, v } from 'convex/values'

export const GT_ORIGIN = 'https://gt.today'

export const dayShareValidator = v.object({
  on: v.boolean(),
  habits: v.boolean(),
  grid: v.boolean(),
  goals: v.boolean(),
  // Number-habit amounts (e.g. kcal); off shows only done / not done.
  numbers: v.boolean(),
  // Titles of tasks done today; the count shows either way.
  tasks: v.optional(v.boolean()),
})

export type DayShare = Infer<typeof dayShareValidator>

export const DAY_SHARE_DEFAULTS: DayShare = {
  on: false,
  habits: true,
  grid: true,
  goals: false,
  numbers: false,
  tasks: false,
}

export const resolveDayShare = (s: Partial<DayShare> | null | undefined): DayShare => ({
  ...DAY_SHARE_DEFAULTS,
  ...s,
})

export const dayShareUrl = (handle: string) => `${GT_ORIGIN}/${handle}`
export const quickLogUrl = (token: string) => `${GT_ORIGIN}/+${token}`

// Mirrors ACCENT_COLORS in the web/native accent pickers. Mono, daily rotation
// and unset fall back to the brand pink.
const APP_ACCENTS: Record<string, string> = {
  lime: '#a8ff3e',
  ocean: '#3da9fc',
  rose: '#ff5c8a',
  aurora: '#2dd4bf',
  ember: '#ff6452',
  gold: '#ffb020',
}
export const BRAND_PINK = '#ec6489'
export const accentValidator = v.union(
  ...(['lime', 'ocean', 'rose', 'aurora', 'ember', 'gold', 'mono', 'rotate'] as const).map((a) =>
    v.literal(a),
  ),
)
export const accentHex = (accent: string | undefined) =>
  (accent && APP_ACCENTS[accent]) || BRAND_PINK

// The Feed's boosts, so gt.today speaks the same language as the app.
export const CHEER_KINDS = ['water', 'sun', 'fire', 'summit'] as const
export type CheerKind = (typeof CHEER_KINDS)[number]
export const cheerKindValidator = v.union(
  v.literal('water'),
  v.literal('sun'),
  v.literal('fire'),
  v.literal('summit'),
)
export const cheerCountsValidator = v.object({
  water: v.number(),
  sun: v.number(),
  fire: v.number(),
  summit: v.number(),
})
export const cheerCounts = (
  row: { water?: number; sun?: number; fire: number; summit?: number } | null,
) => ({
  water: row?.water ?? 0,
  sun: row?.sun ?? 0,
  fire: row?.fire ?? 0,
  summit: row?.summit ?? 0,
})
